import React from "react";
import { connect } from "react-redux";
import { Layout, Typography, Row, Col, Button, Space } from 'antd';
import { Header, AutoCompleteCompany } from "components";
import * as balanceAction from "actions/balance-action";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { isOperatorType } from "utils/static-data";

const { Footer, Content } = Layout;

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        ...balanceAction
    }, dispatch);

const DataFetch = {
    data: [],
    loading: false
}

const CardTypeScreen = (props) => {
    const { login, getCompanyBalanceAction } = props;
    const navigate = useNavigate();
    const [company, setCompany] = React.useState(null);
    const [cardType, setCardType] = React.useState(null);
    const physical = 'physical';
    const virtual = 'virtual';

    const onChangeCompany = (x) => {
        setCompany(x);
    }

    React.useEffect(() => {
        getCompanyBalanceAction();
        if(isOperatorType(login.user.userType) && !login.company.master) {
            setCardType(physical);
        }
    }, [])

    const getQueryString = () => {
        if (login.company.master) {
            return "?company=" + company
        } else {
            return ""
        }
    }

    const getRoutes = () => {
        let routes = []
        if (login.company.master) {
            routes.push({ label: "Desbloqueio de Cartões", route: `/card/list` })
        }
        return routes
    }

    return <Layout className="alymente-layout">
        <Header
            title="Envio de Cartão"
            subtitle="Selecione as opções de envio abaixo"
            routes={
                !cardType ? [] : cardType === physical ? getRoutes() : []
            }
            middle={
                login.company.master ? <AutoCompleteCompany value={company} onChange={onChangeCompany} /> : undefined
            }
        />
        <Content style={{ display: 'flex', alignItems: 'center' }}>
            {
                (!login.company.master || company) &&
                <div style={{ flex: 1 }}>
                    { !cardType ? 
                        <div>
                            <Row justify="center" style={{ marginBottom: 20 }}>
                                <Typography.Text strong>Selecione o tipo de cartão</Typography.Text>
                            </Row>
                            <Row gutter={16} justify="center">
                                    <Col xl={8} lg={11} md={24} sm={24}>
                                        <Button block type="primary" onClick={() => setCardType(physical)}>Físico</Button>
                                    </Col>
                                    <Col xl={8} lg={11} md={24} sm={24}>
                                        <Button block type="primary" onClick={() => setCardType(virtual)}>Virtual</Button>
                                    </Col>
                                </Row>
                        </div>
                        : cardType === physical ?
                        <div>
                            <Row justify="center" style={{ marginBottom: 20 }}>
                                <Typography.Text strong>Aqui você pode fazer um novo envio de cartões:</Typography.Text>
                            </Row>
                            <Row gutter={16} justify="center">
                                <Col xl={8} lg={11} md={24} sm={24}>
                                    <Button block type="primary" onClick={() => navigate("/card/employee" + getQueryString())}>Enviar para a casa do Participante</Button>
                                </Col>
                                <Col xl={8} lg={11} md={24} sm={24}>
                                    <Button block type="primary" onClick={() => navigate("/card/company/matriz" + getQueryString())}>Enviar para a Empresa</Button>
                                </Col>
                                <Col xl={8} lg={11} md={24} sm={24}>
                                    <Button block type="primary" onClick={() => navigate("/card/company/other" + getQueryString())}>Enviar para outro Endereço</Button>
                                </Col>
                            </Row>
                        </div>
                        :
                        <div>
                            <Row justify="center" style={{ marginBottom: 20 }}>
                                <Typography.Text strong>Aqui você pode emitir cartões virtuais:</Typography.Text>
                            </Row>
                            <Row gutter={16} justify="center">
                                <Col xl={8} lg={11} md={24} sm={24}>
                                    <Button block type="primary" onClick={() => navigate("/card/virtual" + getQueryString())}>
                                        Emitir cartão
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    }
                </div>
            }
        </Content>
        <Footer>
            { cardType && !isOperatorType(login.user.userType) &&
                <Space align="end">
                    <Button block type="primary" onClick={() => setCardType(null)}>Voltar</Button>
                </Space>
            }
        </Footer>
    </Layout>
}

export default connect(mapStateToProps, mapDispatchToProps)(CardTypeScreen);
